export const SET_SUB_COMMITTEE_LIST = 'SET_SUB_COMMITTEE_LIST';
export const SET_INITIAL_DATA_VIRTUAL_MEETING = 'SET_INITIAL_DATA_VIRTUAL_MEETING';
export const UPDATE_INITIAL_VALUES = 'UPDATE_INITIAL_VALUES';
export const RESET_INITIAL_VALUES = 'RESET_INITIAL_VALUES'

export default {
    SET_SUB_COMMITTEE_LIST, SET_INITIAL_DATA_VIRTUAL_MEETING,
    UPDATE_INITIAL_VALUES, RESET_INITIAL_VALUES
}